<template>
  <div>
    <Organization
      :v="v"
      :is-alternative-service-edit="isAlternativeServiceEdit"
      :is-manual="false"
      translationKey="noticeRecovery.applicant.org"
		>
			<slot></slot>
		</Organization>

    <MrpaTrustee
      :v="v.trustee"
      label="Сведения о представителе юридического лица"
      :role-type="roleValue"
    />
  </div>
</template>

<script>
import Organization, {
  organizationModel,
  organizationValidation,
} from '../Organization';
import MrpaTrustee, {
  mrpaTrusteeModel,
  getMrpaTrusteeValidation,
} from '@/components/services/elements/MrpaTrustee';
import deepmerge from 'deepmerge';
import { Role } from '@/utils/dictionaries';
import { getValidationErrorText } from '@/utils/validate';

export const machineOrganizationModel = deepmerge(organizationModel, {
  trustee: mrpaTrusteeModel,
});

export const getMachineOrganizationValidation = (organization) => ({
  ...organizationValidation,
  trustee: getMrpaTrusteeValidation(organization.trustee),
});

export default {
  name: 'MachineOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Organization,
    MrpaTrustee,
  },
  data: () => ({
    roleValue: Role.ORGANIZATION,
    getValidationErrorText,
  }),
};
</script>
